export const urls = {
   login: '/login',
   register: '/register',
   allCurrencies: '/currencies',
   currencyByCode: '/currencyByCode',
   changePassword: '/changePassword',
   myDetails: '/myDetails',
   updateUserDetails: '/updateUserDetails',
   changeEmailAddress: '/changeEmailAddress',
   changePasswordAccount: '/changePasswordAccount',
   deleteInvoiceDetails: '/deleteInvoiceDetails',
   addInvoiceDetails: '/addInvoiceDetails',
   updateInvoiceDetails: '/updateInvoiceDetails',
   getInvoiceDetails: '/getInvoiceDetails',
   getinvoice: '/getInvoice',
   manualInvoices: '/manualInvoices',
   manualInvoiceDownload: '/manualInvoiceDownload',
   prepaidManualInvoices: '/prepaidManualInvoices',
   prepaidManualInvoiceDownload: '/prepaidManualInvoiceDownload',
   getInvoiceByAdmin: '/getInvoiceByAdmin',
   downloadTestFile: '/downloadTestFile',
   isAdmin: '/isAdmin',
   isArranger: '/isArranger',
   blockUser: '/blockUser',
   unblockUser: '/unblockUser',
   blockSellingNotes: '/blockSellingNotes',
   addToArrangers: '/addToArrangers',
   removeFromArrangers: '/removeFromArrangers',
   addToAdministrators: '/addToAdministrators',
   removeFromAdministrators: '/removeFromAdministrators',
   getArrangerDetailsByAdmin: '/getArrangerDetailsByAdmin',
   getArrangerCommission: '/getArrangerCommission',
   updateUserDetailsByAdmin: '/updateUserDetailsByAdmin',
   updateArrangerDetailsByAdmin: '/updateArrangerDetailsByAdmin',
   updateArrangerCommissionByAdmin: '/updateArrangerCommissionByAdmin',
   getArrangerDetails: '/getArrangerDetails',
   updateShortDesc: '/updateShortDesc',
   updateFullDesc: '/updateFullDesc',
   updateShortDescByAdmin: '/updateShortDescByAdmin',
   updateFullDescByAdmin: '/updateFullDescByAdmin',
   updateArrangerDetails: '/updateArrangerDetails',
   getUserWithDetails: '/getUserWithDetails',
   getUserSearch: '/getUserSearch',
   getUserAuditHistory: '/getUserAuditHistory',
   getNotesByFilters: '/getNotesByFilters',
   addNote: '/saveNote',
   myNotes: '/myNotes',
   getNoteById: '/getNoteById',
   getEditNoteById: '/getEditNoteById',
   getMyNoteById: '/getMyNoteById',
   getNotesRecentPopular: '/getNotesRecentPopular',
   addCategory: '/addCategory',
   editCategory: '/editCategory',
   getCategories: '/getCategories',
   getAllArrangers: '/getAllArrangers',
   exportUsersToExcel: '/exportUsersToExcel',
   getNotesByCategory: '/getNotesByCategory',
   getAllInformationPages: '/getAllInformationPages',
   updateInformationPage: '/updateInformationPage',
   getInformationPage: '/getInformationPage',
   addToCart: '/storeCart',
   getCart: '/cart',
   deleteItemFromCart: '/deleteItemFromCart',
   addItemsToCart: '/addItemsToCart',
   createOrder: '/createOrder',
   myOrders: '/orders',
   quantityCart: '/quantityCart',
   downloadPreview: '/downloadPreview',
   downloadAudio: '/downloadAudio',
   uploadPhoto: '/uploadPhoto',
   generateTestInvoice: '/generateTestInvoice',
   getInvoiceData: '/getInvoiceData',
   updateInvoiceData: '/updateInvoiceData',
   createPayment: '/createPayment',
   downloadInvoices: '/downloadInvoices',
   downloadNote: '/downloadNote',
   getPrepaidAmount: '/getPrepaidAmount',
   prepaidByCode: '/prepaidByCode',
   addPrepaidCode: '/addPrepaidCode',
   getPrepaidCodes: '/getPrepaidCodes',
   updateContractData: '/updateContractData',
   getContractData: '/getContractData',
   generateTestContract: '/generateTestContract',
   getNotesByCategoryId: '/getAllNotesByCategoryId',
   copyOrMoveNoteCategory: '/copyOrMoveNoteCategory',
   deleteNoteFromCategory: '/deleteNoteFromCategory',
   getArrangerGrossCommision: '/getArrangerGrossCommision',
   orderManagement: '/orderManagement',
   getContract: '/getContract',
   signContract: '/signContract',
   getContractAttachments: '/getContractAttachments',
   saveContractAttachment: '/saveContractAttachment',
   acceptContractAttachment: '/acceptContractAttachment',
   rejectContractAttachment: '/rejectContractAttachment',
   deleteContractAttachment: '/deleteContractAttachment',
   downloadContractAttachment: '/downloadContractAttachment',
   getContractSearchArranger: '/getContractSearchArranger',
   downloadContractAttachmentArranger: '/downloadContractAttachmentArranger',
   deleteContractAttachmentArranger: '/deleteContractAttachmentArranger',
   saveContractAttachmentArranger: '/saveContractAttachmentArranger',
   getContractAttachmentsArranger: '/getContractAttachmentsArranger',
   downloadContract: '/downloadContract',
   getContractEmail: '/getContractEmail',
   sendTestContractEmail: '/sendTestContractEmail',
   editContract: '/editContract',
   submitEditedContract: '/submitEditedContract',
   setContractToDefault: '/setContractToDefault',
   getContractSearch: '/getContractSearch',
   acceptContract: '/acceptContract',
   getDataByNip: '/getDataByNip',
   editOrder: '/editOrder',
   generateZaiksReport: '/generateZaiksReport',
   deleteAccount: '/deleteAccount',
   checkNoteOrderedPayed: '/checkNoteOrderedPayed',
   rateNote: '/rateNote',
   getProfit: '/getProfit',
   verifyChangePasswordCode: '/verifyChangePasswordCode',
   sendVefificationCode: '/sendVefificationCode',
   getArrangerContractSignDate: '/getArrangerContractSignDate',
   updateArrangerContractSignDate: '/updateArrangerContractSignDate',
   verifyChangeEmailCode: '/verifyChangeEmailCode',
   contactform: '/contactform',
};
